module.exports = __webpack_public_path__ + "static/img/test.f2dfd006.png";